import brandPage from './brandPage/actions' // TODO remove with ft brandPage - added 17/06/2020 by @mikediam
import cancelSubscriptionPage from './cancelSubscriptionPage/actions'
import careersPage from './careersPage/actions'
import collectionPage from './collectionPage/actions'
import collectionLandingPage from './collectionLandingPage/actions'
import fragranceOfTheMonthPage from './fragranceOfTheMonthPage/actions'
import invitePage from './invitePage/actions'
import myOrdersPage from './myOrdersPage/actions'
import orderInfoPage from './orderInfoPage/actions'
import productDetailsModal from './productDetailsModal/actions'
import postponedPremiumProduct from './postponedPremiumProduct/actions'
import productPage from './productPage/actions'
import quizPage from './quizPage/actions'
import giftPage from './giftPage/actions'
import incubatorPage from './incubatorPage/actions'
import giftCardPage from './giftCardPage/actions'
import quizRecommendationsPage from './quizRecommendationsPage/actions'
import sentGiftsPage from './sentGiftsPage/actions'
import smartSearchPage from './smartSearchPage/actions'
import pickPage from './pickPage/actions'
import cosmeticsPage from './cosmeticsPage/actions'
import searchResultPage from './searchResultPage/actions'
import zodiacSignPage from './zodiacSignPage/actions'
import popularInStatesPage from './popularInStatesPage/actions'
import requestPage from './requestPage/actions'
import fragranceFinderPage from './fragranceFinderPage/actions'
import trackingPage from './trackingPage/actions'
import profilePage from './profilePage/actions'
import makeupLandingPage from './makeupLandingPage/actions'
import skincareIntroPage from './skincareIntroPage/actions'
import navigation from './navigation/actions'
import fathersDayGiftSetPage from './fathersDayGiftSetPage/actions'
import flashSaleBundlePage from './flashSaleBundlePage/actions'
import caseMonthlyDesignPage from './caseMonthlyDesignPage/actions'
import fragranceConceptsPage from './fragranceConceptsPage/actions'
import queueWidget from './queueWidget/actions'
import improveSurveyPage from './improveSurveyPage/actions'
import shippingAndBillingIssuesModal from './shippingAndBillingIssuesModal/actions'
import improveRecommendationsPage from './improveRecommendationsPage/actions'

import paymentPage from './paymentPage/actions'
import paymentPageNew from './paymentNew/actions'
import redeemQueuePage from './paymentNew/redeemQueuePage/actions'
import redeemTossInPage from './paymentNew/redeemTossInPage/actions'
import subscribePrototypePage from './subscribePrototypePage/actions'


// seoPage actions used only on dev, no need to add it here
export default {
  brandPage,
  cancelSubscriptionPage,
  careersPage,
  collectionPage,
  collectionLandingPage,
  fragranceOfTheMonthPage,
  invitePage,
  myOrdersPage,
  orderInfoPage,
  productDetailsModal,
  postponedPremiumProduct,
  productPage,
  quizPage,
  giftPage,
  incubatorPage,
  giftCardPage,
  quizRecommendationsPage,
  sentGiftsPage,
  smartSearchPage,
  pickPage,
  cosmeticsPage,
  searchResultPage,
  zodiacSignPage,
  popularInStatesPage,
  requestPage,
  fragranceFinderPage,
  trackingPage,
  profilePage,
  makeupLandingPage,
  skincareIntroPage,
  navigation,
  flashSaleBundlePage,
  fathersDayGiftSetPage,
  caseMonthlyDesignPage,
  fragranceConceptsPage,
  queueWidget,
  improveSurveyPage,
  shippingAndBillingIssuesModal,
  improveRecommendationsPage,

  paymentPage,
  paymentPageNew,
  redeemQueuePage,
  redeemTossInPage,
  subscribePrototypePage,
}
